'use client';

import { PropsWithChildren, ReactNode } from 'react';

import { useBreakpoint } from '@flipster/react/misc/responsive';
import { css } from '@flipster/styled-system/css';

import { useIsWebview } from '../../../shared/webview';
import { HistoryTabGroup } from '../constants';
import HistoryTab from './history-tab';

interface Props extends PropsWithChildren {
  title: ReactNode;
  historyTabGroup: HistoryTabGroup;
}

const HistoryPageLayout = ({ title, children, historyTabGroup }: Props) => {
  const isWebview = useIsWebview();
  const { isMobile } = useBreakpoint();
  const isMobileView = isWebview || isMobile;

  return (
    <main
      className={css({
        p: isWebview ? '0 0 48px' : { base: '0 0 56px', tablet: '0 0 150px' },
        tablet: {
          w: 'legacyHdMaxWidth',
          m: '80px auto',
        },
      })}
    >
      <HistoryTab historyTabGroup={historyTabGroup} isMobile={isMobileView} title={title} />
      {children}
    </main>
  );
};

export default HistoryPageLayout;
